import React from "react";
import { Link, useLocation, Navigate } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import GuestHeader from "@/components/GuestHeader";
import BookingAnswers from "@/components/BookingAnswers";
import { getGuest } from "@/lib/guest";
import { formatInTz, useAppTz, tzAbbr } from "@/lib/tz";

export default function GuestConfirmation() {
  const location = useLocation();
  const { name: guestName } = getGuest();
  const booking = location.state?.booking;
  const treatment = location.state?.treatment;
  const tz = useAppTz();

  if (!booking) return <Navigate to="/menu" replace />;

  const dateStr = formatInTz(booking.start_at, { weekday: "long", month: "long", day: "numeric" });
  const timeStr = formatInTz(booking.start_at, { hour: "2-digit", minute: "2-digit", hour12: false });

  return (
    <div className="min-h-screen bg-background">
      <GuestHeader guestName={guestName} />
      <div className="max-w-3xl mx-auto px-6 py-24 text-center" data-testid="confirmation-page">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-accent/15 mb-8">
          <CheckCircle2 className="h-8 w-8 text-accent" strokeWidth={1.5} />
        </div>
        <div className="overline text-accent mb-4">Reservation Confirmed</div>
        <h1 className="font-display text-5xl md:text-6xl tracking-tight leading-[1.05] mb-8">
          See you at<br/><em className="text-accent font-normal">{timeStr}.</em>
        </h1>
        <div className="bg-card border border-border p-8 text-left inline-block min-w-[320px] mb-8">
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div className="overline text-primary/50">Guest</div><div>{booking.guest_name}</div>
            <div className="overline text-primary/50">Treatment</div><div>{treatment?.name || booking.treatment_name}</div>
            <div className="overline text-primary/50">Date</div><div>{dateStr}</div>
            <div className="overline text-primary/50">Time</div><div>{timeStr} <span className="text-xs text-muted-foreground ml-1">({tzAbbr(tz)})</span></div>
            <div className="overline text-primary/50">Duration</div><div>{booking.duration_min} min</div>
          </div>
          <BookingAnswers answers={booking.answers} />
        </div>
        <div>
          <Link to="/reservations">
            <Button className="rounded-full bg-primary hover:bg-primary/90 text-primary-foreground mr-3" data-testid="view-reservations-btn">My reservations</Button>
          </Link>
          <Link to="/menu">
            <Button variant="outline" className="rounded-full border-primary/30" data-testid="back-menu-btn">Back to Menu</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
